import "vant/es/toast/style/less";
import _Toast from "vant/es/toast";
import _regeneratorRuntime from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import axios from 'axios';
import store from '@/store';
import Utils from '@/utils/utils';
import router from '@/router';
import Package from '../../package.json';
import { CURRENT_SECONDARY_BRAND } from '@/config';
import { getAuthToken } from '@/utils/constant'; // 不需要响应拦截的接口地址：

var exceptiveApiUrl = ['/api/opuser/openFuYouWallet', '/api/opclearing/account/bank/bind', '/api/client-ubq-app/lottery/smeltingNfr', '/api/client-ubq-app/scan/openBlindBoxByThirdParty', '/api/client-ubq-app/solicitation/join', '/api/client-ubq-app/bakenAct/assist', '/api/client-ubq-app/order/makeOrder', '/api/client-ubq-app/game/castle/flight/push', '/api/client-ubq-app/game/castle/flight/gameOverPush'];

function isExceptive(url) {
  if (exceptiveApiUrl.length <= 0) return false;
  var item = exceptiveApiUrl.find(function (val) {
    return url.indexOf(val) > -1;
  });
  return !!item;
}

var apiUrl = {
  development: 'https://dev-apimall.ubanquan.cn',
  test: 'https://test-apimall.ubanquan.cn',
  realpre: 'https://realpre-apimall.ubanquan.cn',
  production: 'https://apimall.ubanquan.cn'
};
var staticUrl = {
  development: 'https://dev-apimall.ubanquan.cn',
  test: 'https://test-apimall.ubanquan.cn',
  realpre: 'https://realpre-apimall.ubanquan.cn',
  production: 'https://static.ubanquan.cn'
};
export var superdiamondEnvConfig = {
  production: 'production',
  test: 'test',
  realpre: 'build',
  development: 'development'
};
export var ProductionUrl = apiUrl[process.env.VUE_APP_ENV];
export var ProdStaticUrl = staticUrl[process.env.VUE_APP_ENV]; // 创建 axios 实例

var service = axios.create({
  baseURL: ProductionUrl,
  // withCredentials: true,
  timeout: 40000 // request timeout

}); // 请求拦截

service.interceptors.request.use( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(config) {
    var token;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getAuthToken();

          case 2:
            token = _context.sent;

            if (token) {
              config.headers.token = token;
            } // 二级品牌馆需要额外添加请求头参数
            // ！！！重要提示：二级品牌馆本地开发需手动修改品牌馆id


            config.headers.storeNo = CURRENT_SECONDARY_BRAND.storeNo;
            config.headers.appVersion = Package.version;

            if (Utils.appInfo) {
              config.headers.requestChannel = config.headers.requestChannel || (Utils.isiOS ? 'UBQ_IOS' : 'UBQ_ANDROID');
            } else {
              config.headers.requestChannel = config.headers.requestChannel || 'UBQ_H5';
            }

            return _context.abrupt("return", config);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}(), function (error) {
  console.log(error); // for debug

  return Promise.reject(error);
}); // 统一检查返回状态值

function checkStatus(response) {
  var err = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var status = response.status,
      _response$data = response.data,
      res = _response$data === void 0 ? {} : _response$data;
  var errorMsg = res.errorMsg,
      success = res.success,
      errorCode = res.errorCode; // http状态码不符合条件的跳转繁忙页面

  var _window$location$path = window.location.pathname,
      pathname = _window$location$path === void 0 ? '' : _window$location$path;

  if (status >= 500 && pathname && !pathname.includes('/other/busynessPage')) {
    router.push({
      name: 'busynessPage',
      query: {
        path: window.encodeURIComponent(window.location.href)
      }
    });
    return Promise.reject(false);
  }

  if (err) {
    _Toast(errorMsg || '请求失败!');

    return Promise.reject(res);
  } // /superdiamond/preview/ibmarket/publicity/ 该接口不返回标准格式数据


  if (success === false) {
    // 特定错误弹出toast
    if (errorCode && errorCode.includes('WF')) {
      _Toast(errorMsg);

      return Promise.reject(res);
    } // 无账户 040000: 大额充值未支付订单超限


    if (['100019', '100017', '040000'].includes(errorCode)) {
      return Promise.reject(res);
    } else if (errorCode === '010000') {
      // if (!Utils.appInfo) {
      // token无效，清除
      _Toast('登录已过期，请重新登录~');

      store.dispatch('user/ResetToken').then(function () {
        if (!Utils.appInfo) {
          return router.replace({
            name: 'Login'
          });
        }
      }); // }
    } else if (errorCode === '080020') {// 未设置预警号码，不作任何处理
    } else if (errorCode === '010035') {// 当前用户未实名认证
    } else {
      // 不是例外的api都直接弹出错误信息
      if (!isExceptive(response.config.url)) {
        _Toast(errorMsg || '请求失败');
      }
    }

    return Promise.reject(res);
  }

  return res;
} // 响应拦截


service.interceptors.response.use(function (response) {
  return checkStatus(response);
}, function (error) {
  var response = error.response;

  if (response && response.data) {
    return checkStatus(error.response, true);
  }

  return Promise.reject(error);
});
export default service;